'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

import Error from './error';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  // Check if this is a 410 error
  const is410Error =
    error.message.includes('410') ||
    error.message.includes('Gone') ||
    (error as any).statusCode === 410 ||
    error.name === 'GoneError' ||
    error.name === 'ProductionGoneError';

  if (is410Error) {
    const customError = {
      ...error,
      message: `Gone: The resource is no longer available. Status code: 410`,
    };
    return (
      <html>
        <body>
          <Error error={customError} />
        </body>
      </html>
    );
  }

  const customError = {
    ...error,
    message: `An unexpected error occurred. Status code: 0`,
  };
  return (
    <html>
      <body>
        <Error error={customError} />
      </body>
    </html>
  );
}
